import BookmarkContainer from "../../Componant/Bookmark";

const Bookmark = () => {
  return (
    <div className="page-body">
      <BookmarkContainer />
    </div>
  );
};

export default Bookmark;
